// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3UaIb","imageUploader":"EGiftCard_imageUploader__3ppv2"};